import { AppDefinition } from '../../types/apps';

export const ContactsAppDefinition: AppDefinition = {
  appId: 'contacts',
  name: 'Contacts',
  version: '1.0.0',
  description: 'Your personal CRM. Build and enrich your contact network from Gmail, Calendar, and other integrations.',
  longDescription: `Contacts is River's relationship management system. Create contacts manually or let River auto-discover them from your email threads and calendar events. Every contact is enriched with interaction history, topics you've discussed, recent signals, and AI-suggested reach-out timing.

**Key Features:**
- **Relationships**: Close, Regular, and Archived contacts with cadence-based health checks
- **Auto-discovery**: River scans Gmail and Calendar to find contacts you haven't logged yet
- **AI enrichment**: Extracts topics, signals, preferred channel, and next suggested reach-out from your interaction history
- **Signal feed**: Surface recent signals like job changes, notable activity, or topics to follow up on
- **Automation-ready**: Works with automations to run automated CRM updates`,

  icon: {
    type: 'phosphor',
    phosphorIcon: 'AddressBook',
    phosphorWeight: 'duotone',
    color: '#14b8a6',
  },

  creator: {
    name: 'River',
    verified: true,
  },

  categories: ['Productivity', 'Personal'],
  tags: ['contacts', 'crm', 'relationships', 'networking', 'people'],
  releaseDate: new Date().toISOString(),
  lastUpdated: new Date().toISOString(),

  entityTypes: ['Contact'],
  searchableSkeletonFields: {
    // handles dict is flattened by a dedicated branch in backend compute_search_text()
    Contact: ['company', 'title', 'email', 'tags', 'topics', 'notes', 'primaryChannelContext'],
  },

  component: 'contacts',
  requiresEntity: false,
  requiresProps: false,

  hotkeys: {
    'n': 'newContact',
    'Escape': 'closeDetail',
    '1': 'viewAll',
    '2': 'viewClose',
    '3': 'viewRegular',
    '4': 'viewArchived',
  },

  actions: {
    createContact: {
      name: 'Create Contact',
      description: 'Create a new contact',
      parameters: {
        name: { type: 'string', required: true },
        email: { type: 'string', required: false },
        tier: { type: 'string', required: false, enum: ['close', 'regular', 'archived'] },
        company: { type: 'string', required: false },
      },
    },
    enrichContact: {
      name: 'Enrich Contact',
      description: 'Scan integrations to enrich a specific contact',
      parameters: {
        contactId: { type: 'string', required: true },
      },
    },
    discoverContacts: {
      name: 'Discover Contacts',
      description: 'Auto-discover contacts from Gmail and Calendar',
      parameters: {},
    },
  },
};
